import React from 'react';
import Helmet from 'react-helmet';

// import '../css/blog-post.css';

export default function Template({
  data
}) {
  const { markdownRemark: post } = data;
  return (
    <div className="blog-post-container">
      <Helmet title={`${post.frontmatter.title} - My Awesome Site`} />
      <div className="blog-post">
        <div className="breadcrumbs"><a href="/">Home</a> <a href="/blog/">Blog</a> <span>{post.frontmatter.title}</span></div>
        <img src={post.frontmatter.image} alt={post.frontmatter.title} />
        <h1>{post.frontmatter.title}</h1>
        <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
    </div>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        image
      }
    }
  }
`
;


// WEBPACK FOOTER //
// ./src/templates/blog-post.js